import { render, staticRenderFns } from "./ContractPreview.vue?vue&type=template&id=2f05a078&"
import script from "./ContractPreview.vue?vue&type=script&lang=ts&"
export * from "./ContractPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports